/**
 * @generated SignedSource<<eb178d896ec2b1b69973c432c041f837>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationFeedsOrderBy = "name" | "total_comments" | "total_reactions" | "%future added value";
export type AdminMembersReportFeedsTablePaginationQuery$variables = {
  after?: string | null;
  before?: string | null;
  canRead?: boolean | null;
  direction?: OrderDirection | null;
  excludeProductLevel?: boolean | null;
  first?: number | null;
  id: string;
  last?: number | null;
  memberOrganizationMembershipId: string;
  orderBy?: OrganizationFeedsOrderBy | null;
  productIds?: ReadonlyArray<string> | null;
};
export type AdminMembersReportFeedsTablePaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportFeedsTable_PaginationFragment">;
  } | null;
};
export type AdminMembersReportFeedsTablePaginationQuery = {
  response: AdminMembersReportFeedsTablePaginationQuery$data;
  variables: AdminMembersReportFeedsTablePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canRead"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeProductLevel"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberOrganizationMembershipId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v12 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "canRead",
    "variableName": "canRead"
  },
  {
    "kind": "Variable",
    "name": "direction",
    "variableName": "direction"
  },
  {
    "kind": "Variable",
    "name": "excludeProductLevel",
    "variableName": "excludeProductLevel"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "memberOrganizationMembershipId",
    "variableName": "memberOrganizationMembershipId"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "productIds",
    "variableName": "productIds"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = [
  {
    "kind": "Variable",
    "name": "organizationMembershipId",
    "variableName": "memberOrganizationMembershipId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportFeedsTablePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v12/*: any*/),
            "kind": "FragmentSpread",
            "name": "AdminMembersReportFeedsTable_PaginationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminMembersReportFeedsTablePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "FeedNodeConnection",
                "kind": "LinkedField",
                "name": "feeds",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeedNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Feed",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v16/*: any*/),
                            "kind": "ScalarField",
                            "name": "totalComments",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v16/*: any*/),
                            "kind": "ScalarField",
                            "name": "totalReactions",
                            "storageKey": null
                          },
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "filters": [
                  "memberOrganizationMembershipId",
                  "canRead",
                  "productIds",
                  "excludeProductLevel",
                  "orderBy",
                  "direction"
                ],
                "handle": "connection",
                "key": "AdminMembersReportFeedsTable_feeds",
                "kind": "LinkedHandle",
                "name": "feeds"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1365822d071bbdc2e0eb3c6ed77990e7",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportFeedsTablePaginationQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportFeedsTablePaginationQuery(\n  $after: String\n  $before: String\n  $canRead: Boolean\n  $direction: OrderDirection\n  $excludeProductLevel: Boolean\n  $first: Int\n  $last: Int\n  $memberOrganizationMembershipId: ID!\n  $orderBy: OrganizationFeedsOrderBy\n  $productIds: [ID!]\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...AdminMembersReportFeedsTable_PaginationFragment_10K9RC\n    id\n  }\n}\n\nfragment AdminMembersReportFeedsTableRowFragment_1Enw86 on Feed {\n  id\n  name\n  product {\n    name\n    id\n  }\n  totalComments(organizationMembershipId: $memberOrganizationMembershipId)\n  totalReactions(organizationMembershipId: $memberOrganizationMembershipId)\n}\n\nfragment AdminMembersReportFeedsTable_PaginationFragment_10K9RC on Organization {\n  id\n  feeds(first: $first, after: $after, last: $last, before: $before, memberOrganizationMembershipId: $memberOrganizationMembershipId, canRead: $canRead, productIds: $productIds, excludeProductLevel: $excludeProductLevel, orderBy: $orderBy, direction: $direction) {\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...AdminMembersReportFeedsTableRowFragment_1Enw86\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9528c2e8fc479b5628dd2059cc0fbd18";

export default node;
